import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { LoginService } from 'src/app/login/login.service';
import { TasksHistoriesService } from '../tasks-histories.service';

@Component({
  selector: 'app-tasks-history-detail',
  templateUrl: './tasks-history-detail.component.html',
  styleUrls: ['./tasks-history-detail.component.scss']
})
export class TasksHistoryDetailComponent implements OnInit {
  public taskHistory: any = {};
  constructor(
    private tasksHistoriesService: TasksHistoriesService,
    private config: DynamicDialogConfig,
    private loginService: LoginService,
    private messageService: MessageService,
    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
  ) { }

  ngOnInit(): void {

    if(this.config.data.taskHistory)this.taskHistory = this.config.data.taskHistory;
  }
  save() {
    if (this.taskHistory.message) {
      this.taskHistory.changed_by = this.loginService.get("userId");
      this.taskHistory.changed_at = new Date();
      this.taskHistory.task_id = this.config.data.taskId;

      this.tasksHistoriesService.add(this.taskHistory).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Historial de actividad añadido correctamente" });
          this.cancel();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          this.cancel();
        }
      )
    }
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el registro de actividad?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.tasksHistoriesService.delete(this.taskHistory.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.cancel();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: "No se ha podido borrar el registro." });
            this.cancel();
          }
        )
      },
      reject: () => {

      }
    })
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  isDuplied() {
    this.tasksHistoriesService.isDuplied(this.taskHistory).subscribe(
      data => {
        if(data == true){
          this.coreDialogService.notify({
            message:  "Ya existe un historial de actividad con estos datos proporcionados." ,
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });          
        }else{
          this.save();
        }
      }
    );
  }
}
